import {Class} from '../utils/class.js';
import {emptyElement, createElement, removeElement} from '../utils/dom.js';
import {arrayMatch, arrayClone} from '../utils/array.js';
import {positionRelativeTo} from '../utils/positionrelativeto.js';
import {render, html} from '../lib/lit-html.js';

export var SuggestedQueriesView = new Class({
	constructor: function(store){
		this._store = store;
		this._isVisible = false;
		this._renderedQueries = [];
		this._renderedActiveSuggestedQuery = null;
		this._element = createElement('div.ekm-search-suggested-queries');
		this._element.addEventListener('click', this._onClick.bind(this));

		store.subscribe(this._onStateChange.bind(this));
	},

	_onClick: function(event){
		var el = event.target.closest('.ekm-search-suggested-query');
		
		if (!el) return;
		
		var index = el.getAttribute('data-index');

		this._store.dispatch({
			type: 'SELECT_SUGGESTED_QUERY',
			query: this._renderedQueries[index].value || this._renderedQueries[index]
		});
	},

	_onStateChange: function(state){
		var hasActiveElement = state.inputs.activeElement !== null;

		if (state.suggestions.queries.length === 0 || !hasActiveElement){
			if (!this._isVisible) return;
			removeElement(this._element);
			this._isVisible = false;
			return;
		}

		if (!this._isVisible){
			document.body.appendChild(this._element);
			this._isVisible = true;
		}

		if (
			!arrayMatch(this._renderedQueries, state.suggestions.queries) ||
			this._renderedActiveSuggestedQuery !== state.suggestions.activeQuery
		){
			this._renderedQueries = arrayClone(state.suggestions.queries);
			this._renderedActiveSuggestedQuery = state.suggestions.activeQuery;
			this._renderSuggestedQueries(state);
		}

		this._positionElement(state);
	},

	_emphasise: function(input){
		var a = [];

		var re = /<(\/?em)>/g;

		var prev = 0;
		var r;
		while ((r = re.exec(input)) !== null){
			if (r[1] === 'em'){
				a.push(input.substring(prev, r.index));
			}
			else {
				a.push(createElement('em', input.substring(prev, r.index)));
			}
			prev = re.lastIndex;
		}

		a.push(input.substring(prev));

		return a.filter(function(o){
			return o !== '';
		});
	},

	_renderSuggestedQueries: function(state){
		var queries = state.suggestions.queries;
		var activeSuggestedQuery = state.suggestions.activeQuery;
		
		emptyElement(this._element);

		queries.forEach(function(query, index){
			var isActive = (index === activeSuggestedQuery);

			var content = query;

			if (query.text){
				content = this._emphasise(query.text);
			}

			var el = createElement('div.ekm-search-suggested-query', content);
			el.setAttribute('data-index', index);

			if (isActive) el.classList.add('ekm-search-suggested-query-active');

			this._element.appendChild(el);
		}, this);
	},

	_positionElement: function(state){
		var input = state.inputs.elements[state.inputs.activeElement];

		var anchorSelector = getComputedStyle(input)
			.getPropertyValue('--ekm-search-anchor');

		var refElement = (anchorSelector !== '')
			? input.closest(anchorSelector) || input
			: input;
		
		positionRelativeTo(this._element, refElement);
	}
});